import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './PhraseCell.css';

export interface PhraseCellProps {
    phrase: string;
    minusWords: string[];
    isEditable: boolean;
}

export class PhraseCell extends React.PureComponent<PhraseCellProps> {
    render() {
        const { phrase, minusWords, isEditable } = this.props;

        const prefix = minusWords.length ? ' -' : '';
        const minusWordsString = `${prefix}${minusWords.join(', -')}`;

        const minusWordsElements = minusWords.map((el, index) => (
            <span
                key={el}
                className={Bem.cls('phrase-cell', 'minus-word')}
            >{` -${el}${index < minusWords.length - 1 ? ',' : ''}`}</span>
        ));

        return (
            <div
                className={Bem.cls('phrase-cell')}
                title={`${phrase} ${minusWordsString}`}
            >
                <h3 className={Bem.cls('phrase-cell', 'title')}>
                    {phrase}
                    <span className={Bem.cls('phrase-cell', 'title-suffix')}>
                        {minusWordsElements}
                    </span>
                    {isEditable && (
                        <Shape2
                            width={14}
                            height={14}
                            cls={Bem.cls('phrase-cell', 'edit-icon')}
                            icon={Shape2Icon.edit}
                        />
                    )}
                </h3>
            </div>
        );
    }
}
